export default __webpack_public_path__ + "static/media/cycles_realisticlighttest1_cube.b1d870ee.jpg";